import { AudioWaveform, Brain, ScanLine, ShieldX } from "lucide-react";

export const modalitiesDatas = [
  {
    id: "mri",
    name: "MRI",
    icon: Brain,
    color: "text-blue-400",
  },
  {
    id: "ct",
    name: "CT",
    icon: ScanLine,
    color: "text-blue-400",
  },
  {
    id: "x-ray",
    name: "X-Ray",
    icon: ShieldX,
    color: "text-green-400",
  },
  {
    id: "ultrasound",
    name: "Ultrasound",
    icon: AudioWaveform,
    color: "text-green-400",
  },
]